import { useMemo } from 'react';
import { useLocation as useWouterLocation } from 'wouter';

export const useLocation = () => {
  const [wouterLocation, navigate] = useWouterLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const windowLoc = useMemo(() => window.location, [wouterLocation]);
  return [wouterLocation, windowLoc, navigate];
};
